import { useQuery } from "@tanstack/react-query";
import { CACHE_KEY_LOCATIONS } from "../../../utils/constants";
import { LocationInterface } from "../../../models/TicketModule/Location";
import locationService from "../../../services/ticketService/locationService";

const useLocationsById = (id: string) =>
  useQuery<LocationInterface, Error>({
    queryKey: [`${CACHE_KEY_LOCATIONS}ById`, id],
    queryFn: ({ queryKey }) => {
      const [, locationId] = queryKey;
      return locationService.GetById(locationId as string);
    },
    enabled: !!id,
  });

export default useLocationsById;
